export default class RemindPasswordData {
    email = ''
}
